import ScreenHeader from "@/components/ScreenHeader";
import "./style.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";
import Card from "../../../shared/Card/Card";

const Biometric = ({ data }) => {
  const { t } = useTranslation();
  const { requestData, patientData } = data || {};
  if (!requestData) return null;

  return (
    <div className="bg-white biometric-container mt-4">
      <ScreenHeader title="biometric-health-snapshot" icon="solar:user-outline" className="bg-transparent mx-0 px-0 doc-header" />
      <div className="biometric-grid">
        <Card icon="solar:ruler-pen-outline" title={t("height")} value={patientData.height} className="biometric-card" />
        <Card icon="mdi:weight" title={t("weight")} value={patientData.weight} className="biometric-card" />
        <Card icon="solar:heart-angle-outline" title={t("marital-status")} value={patientData.maritalStatus} className="biometric-card" />
        <Card icon="solar:fire-outline" title={t("smoking")} value={patientData.isSmoker} className="biometric-card" />
        <Card icon="game-icons:glass-shot" title={t("alcohol")} value={patientData.isDrinkAlcohol} className="biometric-card" />
        <Card icon="hugeicons:stethoscope" title={t("prev-operations")} value={patientData.medicalOperation} className="biometric-card" />
        <Card 
          icon="solar:thermometer-outline" 
          title={t("allergies")} 
          className="biometric-card"
          value={Array.isArray(patientData.allergy) ? patientData.allergy.join(", ") : patientData.allergy} 
          isAlert={true} 
        />
        <Card 
          icon="solar:pill-outline" 
          title={t("current-meds")} 
          className="biometric-card"
          value={Array.isArray(patientData.regularMedicationName) ? patientData.regularMedicationName.join(", ") : patientData.regularMedicationName} 
        />
      </div>
    </div>
  );
};

export default Biometric;

